export function filterImage(url, side) {
  const isHttpUrl = url && url.indexOf('http') === -1

  if (!isHttpUrl) return url

  if (side) url += `?x-oss-process=image/resize,m_fill,w_${side}`

  return process.env.VUE_APP_FILE_URL + url
}

export function formatGender(val) {
  const map = {
    0: '未知',
    1: '男',
    2: '女'
  }

  return map[val] || val
}

export function filterPrice(val) {
  if (!(val % 100)) return parseInt(val / 100, 10)

  return (val / 100).toFixed(val % 10 ? 2 : 1)
}

export function filterDotPrice(val) {
  return (val % 100).toString().padStart(2, '0')
}

export function filterActivtyType(val) {
  if (val === 'GENERAL') return '-'

  const map = {
    HELPCUT: '好友砍价',
    GROUPON: '拼团购',
    LIMITDISCOUNT: '特价促销',
    SECKILL: '限时秒杀'
  }

  return map[val] || val
}

export function filterTimeStyle(val) {
  return `${val.substring(0, 10).replace(/-/g, '.')} ${val.substring(11)}`
}

export function filterTimeStamp(timestamp) {
  let newDate = timestamp
  if (Number.isInteger(timestamp)) {
    newDate = new Date(timestamp)
  }
  const year = newDate.getFullYear()
  const month = (newDate.getMonth() + 1).toString().padStart(2, '0')
  const date = newDate.getDate().toString().padStart(2, '0')
  const hour = newDate.getHours().toString().padStart(2, '0')
  const minute = newDate.getMinutes().toString().padStart(2, '0')
  const second = newDate.getSeconds().toString().padStart(2, '0')

  return `${year}-${month}-${date} ${hour}:${minute}:${second}`
}

export function filterPrecent(val) {
  if (!val) return '0%'
  return `${(val * 100).toFixed(2)}%`
}
